import logo from "./logo.svg";
import "./App.css";
import HomePage from "./HomePage/HomePage";

function App() {
  return (
    <div>
      <HomePage></HomePage>
    </div>
  );
}

export default App;
